/* Gestion du menu */

import { valueResponsiveMenu, witdhWindow, isMobile } from './utilities'

// A chaque resize du nagigateur
window.addEventListener('resize', function () {
    isMobile();
});

/* Interactions du menu */

const menu = document.querySelector('#site-navigation'),
    content = document.querySelector('.site-content'),
    allItemsLevel0 = document.querySelectorAll("#primary-menu-list > .level-0.menu-item"),
    allSubMenus = document.querySelectorAll('#primary-menu-list > .menu-item > .sub-menu__wrapper'), // Tous les .sub-menu__wrapper, 
    allItemsMenu = document.querySelectorAll('#primary-menu-list > .menu-item'), // TOUS LES .menu-item 
    allItemsMenuLink = document.querySelectorAll('#primary-menu-list > .menu-item > a'),// Tous les .menu-item > a, 
    activeElement = document.activeElement, // Dernier élément du menu complet
    lastMenuItem = getLastElement(document.querySelector("#primary-menu-list")), // Dernier élément du menu complet
    subMenuWrappers = document.querySelectorAll('#primary-menu-list > .menu-item > .sub-menu__wrapper'),
    closeIcons = document.querySelectorAll('.close-icon');

let isKeyDown = false;

document.addEventListener("keydown", (event) => {
    isKeyDown = true
})

// Au chargement de la page
window.addEventListener('load', function () {
    isMobile();
    // attribue l'ID d'un sub-menu__wrapper enfant à son <li> Parent
    allItemsLevel0.forEach(ItemsMenu0 => {
        var ItemsLevel1 = ItemsMenu0.querySelector('.sub-menu__wrapper');

        if(ItemsLevel1) {
            var idItemsLevel1 = ItemsLevel1.id
            ItemsMenu0.querySelector('.menu-link').setAttribute('aria-controls', idItemsLevel1);
        }
    });
});

// Touche echap
document.addEventListener("keydown", (event) => {
    if (event.key === 'Escape') {
        closeMenu();

        if((window.innerWidth > 1020) && (document.querySelector('.sub-menu-open'))) {
            document.body.classList.remove('sub-menu-open');
            document.body.classList.add('sub-menu-close');

            var iconsChevron = document.querySelectorAll('.menu-link-icon');

            iconsChevron.forEach((iconChevron) => {
                iconChevron.classList.remove('icon-chevron-rotate');
            });
        }
    }
});

// Quand on quitte le focus du dernier item du menu, on ferme le menu
lastMenuItem.addEventListener("focusout", (event) => {
    if (!(isMobile())) {
        closeMenu();

        if((window.innerWidth > 1020) && (document.querySelector('.sub-menu-open'))) {
            document.body.classList.remove('sub-menu-open');
            document.body.classList.add('sub-menu-close');

            var iconsChevron = document.querySelectorAll('.menu-link-icon');

            iconsChevron.forEach((iconChevron) => {
                iconChevron.classList.remove('icon-chevron-rotate');
            });
        }
    }
});

// Fermer le menu Desktop si click outside 
window.addEventListener('click', function (event) {
    if (((event.target.contains(menu) || event.target.contains(content)) && event.target !== menu)) {
        closeMenu();

        if((window.innerWidth > 1020) && (document.querySelector('.sub-menu-open'))) {
            document.body.classList.remove('sub-menu-open');
            document.body.classList.add('sub-menu-close');
        }
    }
})

closeIcons.forEach(closeIcon => {
    closeIcon.addEventListener("click", (event) => {
        closeMenu();

        if(window.innerWidth > 1020) {
            document.body.classList.remove('sub-menu-open');
            document.body.classList.add('sub-menu-close');
            var iconsChevron = document.querySelectorAll('.menu-link-icon');

            iconsChevron.forEach((iconChevron) => {
                iconChevron.classList.remove('icon-chevron-rotate');
            });
        }
    });
})

// Au clic sur un item du menu
allItemsMenu.forEach(menuItem => {
    menuItem.addEventListener('click', function (event) {
        let thisItem = this;
        if (thisItem.classList.contains('menu-item-has-children')) {
            event.preventDefault();
            menuNavigation(witdhWindow, thisItem);

            thisItem.querySelector('.menu-link-icon').classList.toggle('icon-chevron-rotate');

            removeAll(this);
        }
    })
})

function removeAll(exceptThis) {
    for (var i = 0; i < allItemsMenu.length; i++) {
      if (allItemsMenu[i] !== exceptThis) {
        allItemsMenu[i].querySelector('.menu-link-icon').classList.remove('icon-chevron-rotate');
      }
    }
  }

subMenuWrappers.forEach(subMenuWrapper => {
    subMenuWrapper.addEventListener('click', function (event) {
        event.stopPropagation();
    })
})

// recupère le dernier item le l'ensemble des items du menu
function getLastElement(structure) {
    if (structure.children.length === 0) {
        return structure;
    } else {
        const lastChild = structure.children[structure.children.length - 1];
        return getLastElement(lastChild);
    }
}

// ferme tous les submenu et ouvre le cliqué
function closeMenu() {
    allSubMenus.forEach(SubMenu => {
        SubMenu.classList.remove('sub-menu__wrapper--open');
    })

    allItemsMenu.forEach(ItemsMenu => {
        ItemsMenu.classList.remove('active-mobile-parent');
    })

    allItemsMenuLink.forEach(ItemsMenu => {
        ItemsMenu.setAttribute("aria-expanded", false);
    })
}

// Navigation dans le menu Desktop et Mobile
function menuNavigation(witdhWindow, thisItem) {

    // .menu-item CLIQUÉ
    thisItem
    // .menu-item > a CLIQUÉ
    let thisItemLink = thisItem.querySelector('a');
    let thisSubMenu = null
    for (let i = 0; i < thisItem.childNodes.length; i++) {

        if ((thisItem.childNodes[i].className == ("sub-menu__wrapper")) || (thisItem.childNodes[i].className == ("sub-menu__wrapper sub-menu__wrapper--open"))) {
            thisSubMenu = thisItem.childNodes[i];
            break;
        }
    }

    // indiquer sur le body que le menu est ouvert

    if(window.innerWidth > 1020) {
        document.body.classList.add('sub-menu-open');
        document.body.classList.remove('sub-menu-close');
    }

    if (thisItem.classList.contains('active-mobile-parent')) {

        // ferme le .sub-menu 

        thisItem.classList.remove('active-mobile-parent');
        thisSubMenu.classList.remove('sub-menu__wrapper--open');
        thisItemLink.setAttribute("aria-expanded", false);
        thisItemLink.setAttribute("aria-current", false);

        if(window.innerWidth > 1020) {
            document.body.classList.remove('sub-menu-open');
            document.body.classList.add('sub-menu-close');
        }

    } else {

        // ferme tous les submenu et ouvre le cliqué

        allSubMenus.forEach(SubMenu => {
            SubMenu.classList.remove('sub-menu__wrapper--open');
        })

        allItemsMenu.forEach(ItemsMenu => {
            ItemsMenu.classList.remove('active-mobile-parent');
        })

        allItemsMenuLink.forEach(ItemsMenu => {
            ItemsMenu.setAttribute("aria-expanded", false);
        })

        thisItem.classList.add('active-mobile-parent');
        thisSubMenu.classList.add('sub-menu__wrapper--open');
        thisItemLink.setAttribute("aria-expanded", true);
        thisItemLink.setAttribute("aria-current", true);

        if(window.innerWidth > 1020) {
            document.body.classList.add('sub-menu-open');
            document.body.classList.remove('sub-menu-close');
        }
    }
}